export const en = {
    'condition-type-all': 'All fulfilled',
    'condition-type-not': 'None fulfilled',
    'condition-type-or': 'At least one fulfilled',
    'day-description': {
        one: 'over {count} day',
        some: 'over {count} days',
        many: 'over {count} days',
        none: ''
    },
    'no-metrika-goal-value': 'Goal not found',
    'no-segment-value': 'Segment not found',
    'status-active': 'Active',
    'status-stopped': 'Stopped'
};
